import { readUnhandledEnumCase } from 'rpc-client-utils';
const AWARD_TYPE_MAP = {
  BADGE: 'badge',
  CERTIFICATION: 'certification',
  ACCREDITATION: 'accreditation'
};
export function toAwardType(credentialType) {
  var _AWARD_TYPE_MAP$key;
  if (!credentialType) return 'certification';
  const key = readUnhandledEnumCase(credentialType);
  return (_AWARD_TYPE_MAP$key = AWARD_TYPE_MAP[key]) !== null && _AWARD_TYPE_MAP$key !== void 0 ? _AWARD_TYPE_MAP$key : 'certification';
}
export function cleanTrackingProps(props) {
  return Object.fromEntries(Object.entries(props).filter(([, v]) => v != null));
}